{
  "es": {
    "window": {
      "app": "App",
      "customersAnnouncements": "Novedades del proyecto",
      "customersDashboard": "Inicio",
      "customersDecisionDocuments": "Decisión",
      "customersDecisionProposals": "Propuestas de decisión",
      "customersDecisionTickets": "Decisión",
      "customersDecisionTicketsShow": "Decisión",
      "customersDecisions": "Decisiones",
      "customersDocuments": "Documentos",
      "customersDocumentsAll": "Vista general de documentos",
      "customersDocumentsFolder": "Categoría de documentos",
      "customersDocumentsFolders": "Categorías de documentos",
      "customersInspirationLists": "Inspiración",
      "customersInspirationListsShow": "Inspiración",
      "customersInstallmentTerms": "Cuotas",
      "customersIssues": "Posventa",
      "customersIssuesList": "Posventa",
      "customersProjectInformation": "Información del proyecto",
      "customersQuestionLists": "FAQ",
      "customersQuestionListsShow": "FAQ",
      "customersRoot": "Inicio",
      "customersRootSettingsProfile": "Ajustes",
      "customersSettingsProfile": "Ajustes",
      "customersTickets": "Conversaciones",
      "customersTicketsNew": "Nueva conversación",
      "customersTicketsShow": "Conversación",
      "employeesClientContacts": "Contactos",
      "employeesClientContactsNew": "Nuevo contacto",
      "employeesClientContactsNewCustomer": "Nuevo cliente",
      "employeesClientContactsNewPartner": "Nuevo colaborador",
      "employeesClientContactsType": "Contactos",
      "employeesClientDashboard": "Inicio",
      "employeesClientProjects": "Proyectos",
      "employeesClientProjectsNew": "Nuevo proyecto",
      "employeesClientTickets": "Conversaciones",
      "employeesClientTicketsNew": "Nueva conversación",
      "employeesClientTicketsShow": "Conversación",
      "employeesMarketplace": "Marketplace",
      "employeesProjectActivity": "Actividad",
      "employeesProjectAnnouncements": "Novedades",
      "employeesProjectDecisionActivity": "Actividad",
      "employeesProjectDecisionDocuments": "Decisión",
      "employeesProjectDecisionProposalTemplate": "Plantillas de propuestas",
      "employeesProjectDecisionProposals": "Propuestas",
      "employeesProjectDecisionReminders": "Recordatorios",
      "employeesProjectDecisionTickets": "Conversaciones",
      "employeesProjectDecisionTicketsShow": "Conversación",
      "employeesProjectDecisionTypeNew": "Nueva decisión",
      "employeesProjectDecisionTypes": "Decisiones",
      "employeesProjectDecisions": "Decisiones",
      "employeesProjectDecisionsEdit": "Decisiones",
      "employeesProjectDecisionsNew": "Nueva decisión",
      "employeesProjectDocuments": "Documentos",
      "employeesProjectInformationPageActivity": "Actividad",
      "employeesProjectInformationPageAftercare": "Posventa",
      "employeesProjectInformationPageDecisions": "Decisiones",
      "employeesProjectInformationPageDocuments": "Documentos",
      "employeesProjectInformationPageInformation": "Información",
      "employeesProjectInformationPageInstallments": "Cuotas",
      "employeesProjectInformationPageLevels": "Niveles",
      "employeesProjectInformationPageMilestones": "Workflows",
      "employeesProjectInformationPageSpaces": "Anejos",
      "employeesProjectInformationPageSurveys": "Encuestas",
      "employeesProjectInformationPageTaskAssignments": "Tareas",
      "employeesProjectInformationPageTasks": "Tareas",
      "employeesProjectInformationPageTickets": "Conversaciones",
      "employeesProjectInstallmentGroup": "Finanzas",
      "employeesProjectInstallmentGroupNew": "Nuevo grupo de cuotas",
      "employeesProjectInstallmentGroups": "Finanzas",
      "employeesProjectInstallmentGroupsList": "Finanzas",
      "employeesProjectInstallmentGroupsMatrix": "Cuotas",
      "employeesProjectInstallmentNew": "Nuevas cuotas",
      "employeesProjectIssueListTypeIssues": "Lista de incidencias - Todas las incidencias",
      "employeesProjectIssueListTypeNew": "Nueva lista de incidencias",
      "employeesProjectIssueListTypeUnits": "Lista de incidencias - Vista general por unidad",
      "employeesProjectIssueListTypes": "Listas de incidencias",
      "employeesProjectIssueListUnitDocuments": "Incidencias de la unidad - Documentos",
      "employeesProjectIssueListUnitIssues": "Incidencias de la unidad",
      "employeesProjectIssueListUnitTickets": "Incidencias de la unidad - Conversaciones",
      "employeesProjectIssueListUnitTicketsShow": "Conversaciones",
      "employeesProjectIssueListsNew": "Nuevas incidencias",
      "employeesProjectMilestones": "Workflows",
      "employeesProjectQuestionLists": "FAQ",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSalesUnits": "Ventas",
      "employeesProjectSurveySummary": "Encuesta",
      "employeesProjectSurveyTypes": "Encuestas",
      "employeesProjectSurveys": "Encuesta",
      "employeesProjectTasks": "Tareas",
      "employeesProjectTickets": "Conversaciones",
      "employeesProjectTicketsEmailConversations": "Correos",
      "employeesProjectTicketsEmailConversationsShow": "Correo",
      "employeesProjectTicketsNew": "Nueva conversación",
      "employeesProjectTicketsShow": "Conversaciones",
      "employeesProjectTodoLists": "Tareas",
      "employeesSettingsClientAftercare": "Posventa",
      "employeesSettingsClientInformation": "Administración",
      "employeesSettingsClientIntegrations": "Integraciones",
      "employeesSettingsProfile": "Perfil",
      "level": "Nivel",
      "mployeesProjectInstallmentGroups": "Finanzas",
      "partnersClientProjects": "Proyectos",
      "partnersProjectDecisionDocuments": "Documentos",
      "partnersProjectDecisionProposals": "Propuestas",
      "partnersProjectDecisionTickets": "Conversaciones",
      "partnersProjectDecisionTicketsShow": "Conversación",
      "partnersProjectDecisionTypesItems": "Decisiones",
      "partnersProjectDecisions": "Decisiones",
      "partnersProjectDocuments": "Documentos",
      "partnersProjectDocumentsUnit": "Documentos",
      "partnersProjectIssueListTypeIssues": "Lista de incidencias - Todas las incidencias",
      "partnersProjectIssueListTypeUnits": "Lista de incidencias - Vista general por unidad",
      "partnersProjectIssueListTypes": "Posventa",
      "partnersProjectIssueListUnitDocuments": "Incidencias de la unidad - Documentos",
      "partnersProjectIssueListUnitIssues": "Incidencias de la unidad",
      "partnersProjectIssueListUnitTickets": "Incidencias de la unidad - Conversaciones",
      "partnersSettingsProfile": "Perfil",
      "root": "App",
      "usersPaused": "Tu acceso está en pausa"
    }
  }
}
